import classNames from "classnames";
import { useKeyPress } from "ahooks";
import { When } from "react-if";
import { SHORTCUT } from "@/constants/shortcut";
import isEditingElement from "@/utils/isEditingElement";

import HBIcon from "../../components/HBIcon";

import styles from "./index.module.less";

export default function NewMessage({ title, length, onClick }) {
  useKeyPress(
    SHORTCUT.SHOW_NEW_PIN,
    () => {
      const editing = isEditingElement();
      if (editing) {
        return false;
      }

      if (length > 0) {
        onClick && onClick();
      }
    },
    {
      exactMatch: true,
    }
  );

  return (
    <When condition={length > 0}>
      <div className={classNames(styles.container, "modalOpenWidth")}>
        <div className={styles.message} onClick={onClick}>
          <HBIcon className={styles.icon} type="ic_logo" />
          <div className={styles.desc}>{`${
            length >= 100 ? "100+" : length
          }新${title}`}</div>
        </div>
      </div>
    </When>
  );
}
